/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const Item = ({ module, errors }) => {
  const { media } = useMedia(getImage(module.content));

  return (
    <InfoItem.WithError error={errors} size="large" image={media.src} description={module.content.title}>
      Newsletter sign up
    </InfoItem.WithError>
  );
};

export default Item;
